import React from 'react';
import { Heading } from '@applyboard/crystal-ui';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var PageSectionTitle = function PageSectionTitle(_ref) {
  var title = _ref.title;
  return _jsx(Heading, {
    level: 2,
    variant: "titleM",
    children: title
  });
};